import React from 'react';

/* Los campos que cada negocio necesita en su ficha de lead.

   No todos los clientes venden lo mismo: a una organizadora de eventos le
   importa la fecha, la ciudad y cuánta gente va; a otro le importarán otras
   cosas. En vez de llenar la tabla de columnas que la mayoría deja vacías, cada
   cliente define los suyos y se guardan en `extra_data` del lead.

   La definición vive en la configuración del CRM, en `lead_fields`:

     [{ "key": "fecha_evento", "label": "Fecha del evento", "tipo": "date",
        "lista": true, "opciones": [] }]

   `tipo`: text | date | number | select | textarea
   `lista`: si además se muestra como columna en el listado de leads. */

export function leerCampos(settings) {
  try {
    const crudo = settings?.lead_fields;
    if (!crudo) return [];
    const campos = typeof crudo === 'string' ? JSON.parse(crudo) : crudo;
    return Array.isArray(campos) ? campos.filter(c => c && c.key) : [];
  } catch { return []; }   // una config rota no puede romper la pantalla
}

// El valor de un campo propio, venga el JSON como objeto o como texto
export function valorDe(lead, key) {
  const d = typeof lead?.extra_data === 'string'
    ? (() => { try { return JSON.parse(lead.extra_data || '{}'); } catch { return {}; } })()
    : (lead?.extra_data || {});
  const v = d?.[key];
  return v === undefined || v === null ? '' : v;
}

// Para mostrar: las fechas en formato de acá, el resto tal cual
export function mostrar(campo, valor) {
  if (valor === '' || valor === null || valor === undefined) return '—';
  if (campo.tipo === 'date') {
    const s = String(valor).slice(0, 10).split('-');
    return s.length === 3 ? `${s[2]}/${s[1]}/${s[0]}` : String(valor);
  }
  if (campo.tipo === 'number') return Number(valor).toLocaleString('es-AR');
  return String(valor);
}

export default function CamposPropios({ campos, valores, onCambio, titulo = 'Datos del evento' }) {
  if (!campos.length) return null;
  return (
    <div className="card" style={{ marginBottom: 16 }}>
      <h3 style={{ fontSize: 15, fontWeight: 700, marginBottom: 14 }}>{titulo}</h3>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))', gap: 12 }}>
        {campos.map(c => (
          <div className="form-group" key={c.key} style={c.tipo === 'textarea' ? { gridColumn: '1 / -1' } : undefined}>
            <label>{c.label || c.key}</label>
            {c.tipo === 'select' ? (
              <select value={valores[c.key] ?? ''} onChange={e => onCambio(c.key, e.target.value)}>
                <option value="">—</option>
                {(c.opciones || []).map(o => <option key={o} value={o}>{o}</option>)}
              </select>
            ) : c.tipo === 'textarea' ? (
              <textarea rows={2} value={valores[c.key] ?? ''} onChange={e => onCambio(c.key, e.target.value)}
                style={{ fontFamily: 'inherit', fontSize: 13 }} />
            ) : (
              <input type={c.tipo === 'date' ? 'date' : c.tipo === 'number' ? 'number' : 'text'}
                value={valores[c.key] ?? ''} onChange={e => onCambio(c.key, e.target.value)}
                placeholder={c.placeholder || ''} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
